import { createAsyncThunk } from '@reduxjs/toolkit';
import api from '~api/address';

export const list = createAsyncThunk(
  'address/list',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.getAddress();
      return response.data;
    } catch (error) {
      console.error('Error fetching address list:', error);
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const create = createAsyncThunk(
  'address/create',
  async (payload, { getState }) => {
    const { address } = getState();
    const hasDefaultAddress = Object.keys(address.default).length > 0;
    if (payload.is_default && hasDefaultAddress) {
      await api.updateAddress({
        id: address.default._id,
        payload: { ...address.default, is_default: false },
      });
    }
    const response = await api.createAddress(payload);
    return response.data;
  },
);

export const update = createAsyncThunk(
  'address/update',
  async ({ id, payload }, { getState }) => {
    const { address } = getState();
    const hasDefaultAddress = Object.keys(address.default).length > 0;
    if (payload.is_default && hasDefaultAddress) {
      await api.updateAddress({
        id: address.default._id,
        payload: { ...address.default, is_default: false },
      });
    }
    const response = await api.updateAddress({ id, payload });
    return response.data;
  },
);

export const remove = createAsyncThunk('address/remove', async ({ id }) => {
  const response = await api.deleteAddress({ id });
  return response.data;
});

export const setDefault = createAsyncThunk(
  'address/setDefault',
  async (payload, { getState }) => {
    const { address } = getState();
    if (Object.keys(address.default).length > 0) {
      await api.updateAddress({
        id: address.default._id,
        payload: { ...address.default, is_default: false },
      });
    }
    const response = await api.updateAddress({
      id: payload._id,
      payload: { ...payload, is_default: true },
    });
    return response.data;
  },
);

export const getSingleAddress = createAsyncThunk(
  'address/getSingleAddress',
  async (id) => {
    const response = await api.getAddress();
    let editAddress;
    response.data.data[0].address.forEach((item) => {
      if (item['_id'] === id) {
        editAddress = item;
      }
    });
    return editAddress;
  },
);

export const select = createAsyncThunk('address/select', async ({ id }) => {
  const response = await api.selectAdress({ id });
  return response.data;
});
